import {SelectPopover} from '@/components/ui/select-atoms/SelectAtoms'
import styled, {css} from 'styled-components'

export const StyledSelectPopover = styled(SelectPopover)<{$hasGroups: boolean}>(
    ({$hasGroups}) => css`
        ${$hasGroups &&
        css`
            padding: 0;
        `}
    `
)
